/*
 * Copyright (c) 2017-2021. Code réalisé par IpsoSenso.
 */

import React from 'react'
import UploadFileInput from './internal/UploadFileInput'
import mapError from 'isotope-client/components/form/fields/mapError'

const FormInputHoc = (Component) => (
	{
		input: {
			...inputProps
		},
		meta: {
			error,
			submitError,
			dirty,
			...otherMeta
		},
		...otherProps
	}
) => {
	return <Component
		{...otherProps}
		{...inputProps}
		meta={otherMeta}
		dirty={dirty}
		error={error || submitError}
	/>
}

const EnhancedUploadFileInput = FormInputHoc(UploadFileInput)

export default mapError(EnhancedUploadFileInput)

